import { SagaIterator } from "redux-saga";

import { DataProvider } from "@com.mgmtp.a12.client/client-core/lib/core/data";

import { PERMISSON_DATAHOLDER } from "../modules/processOverview/store/constants";

/*
A data provider for data holders that are not persisted / transient.
It doesn't do anything, basically (but it is required to have one per data holder))
 */
class TransientDataProvider implements DataProvider {
	readonly name: string = "NoopDataProvider";

	canHandle({ dataHolder, operation }: DataProvider.CanHandleConfig): boolean {
		if (!(
			"validationInfo" in dataHolder.descriptor ||
			PERMISSON_DATAHOLDER in dataHolder.descriptor ||
			dataHolder.descriptor.type === "contactData"
		)) {
			return false;
		}

		switch (operation) {
			case "load":
			case "save":
				return true;
			case "delete":
			default:
				return false;
		}
	}

	*provideData(): SagaIterator<void> {
		// Noop
	}
}

export const transientDataProvider = new TransientDataProvider();
